const INITIAL_STATE = {
  settings: {
    pegasus: {
      platform: 'web',
      deviceUuid: '1880',
      mocked: false,
      sduiVersion: '8',
    },
  },
};

export default function reducer(state = INITIAL_STATE) {
  return state;
}
